import React, { useState, useEffect, useCallback } from 'react';
import apiClient from '../services/api';
import { PageContentWrapper, PageHeader, PageDescription } from '../main/LayoutStyles';
import { Card, AlertBox } from '../main/CommonStyles';
import { AppointmentList, AppointmentCard, AppointmentDetails, StatusBadge } from './MyAppointmentsStyles';
import { Loader2, AlertTriangle, CalendarCheck } from 'lucide-react';

const MyAppointments = () => {
    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchAppointments = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiClient.get('/appointments/patient');
            setAppointments(response.data);
        } catch (err) {
            setError('Nie udało się pobrać listy Twoich wizyt.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchAppointments();
    }, [fetchAppointments]);

    if (loading) {
        return <PageContentWrapper><div style={{textAlign: 'center'}}><Loader2 className="icon-spin" /> Ładowanie...</div></PageContentWrapper>;
    }

    if (error) {
        return <PageContentWrapper><AlertBox type="error"><AlertTriangle /> {error}</AlertBox></PageContentWrapper>;
    }

    return (
        <PageContentWrapper className="custom-scrollbar">
            <PageHeader>Moje Wizyty</PageHeader>
            <PageDescription>Tutaj znajdziesz listę swoich nadchodzących i przeszłych wizyt.</PageDescription>
            <AppointmentList>
                {appointments.length > 0 ? appointments.map(app => (
                    <AppointmentCard key={app.id} status={app.status}>
                        <div className="icon-area">
                            <CalendarCheck size={32} />
                        </div>
                        <AppointmentDetails>
                            <p><strong>Specjalista:</strong> {app.psychologistUsername}</p>
                            <p><strong>Data:</strong> {new Date(app.startTime).toLocaleString('pl-PL', { dateStyle: 'full', timeStyle: 'short' })}</p>
                        </AppointmentDetails>
                        <StatusBadge status={app.status}>
                            {app.status.replace(/_/g, ' ').toLowerCase()}
                        </StatusBadge>
                    </AppointmentCard>
                )) : (
                    <Card style={{textAlign: 'center'}}>
                        <p>Nie masz jeszcze żadnych zaplanowanych wizyt.</p>
                    </Card>
                )}
            </AppointmentList>
        </PageContentWrapper>
    );
};

export default MyAppointments;